function _(n,r,t){var _=n(113),e=function(n){function r(r){return n.call(this,r)||this}return _.__extends(r,n),r}(n(166).Model);t.Transform=e,e.__name__="Transform"}
//# sourceMappingURL=transform.min.js.map